<template>
  <div>
    <v-list
      v-if="lastVer !== currVer"
      dense
      class="py-2">
      <v-list-tile
        :href="crxHref"
        target="_blank"
      >
        <v-icon>file_download</v-icon>
        <v-list-tile-content>
          <v-list-tile-title class="pl-2">
            Chrome 擴充
            <span @click.stop.prevent>
              <Tooltips >
                <h4 class="mb-1">Chrome 擴充安装步骤：</h4>
                STEP 1：<br>
                將 ZIP 格式擴充套件解壓縮至獨立的資料夾<br>
                <br>
                STEP 2：<br>
                Chrome 進入擴充功能頁面（chrome://extensions/）<br>
                將右邊的「開發人員模式」啟用<br>
                <br>
                STEP 3：<br>
                按下左邊出現的「載入未封裝項目」<br>
                選擇剛剛解壓縮的擴充套件資料夾即可
              </Tooltips>
            </span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <div
      v-if="installed && lastVer !== currVer"
      class="py-2 red white--text text-xs-center">
      <div class="mb-2">
        擴充需要更新
      </div>
      <div>
        當前版本：{{ currVer }}
      </div>
      <div>
        最新版本：{{ lastVer }}
      </div>
    </div>

    <div
      v-else-if="installed && lastVer === currVer"
      class="py-2 grey white--text text-xs-center">
      <div>
        已安裝擴充：{{ currVer }}
      </div>
    </div>

    <!-- <Schedule
      :interval="10000"
      @exec="checkCrx"
    /> -->
  </div>
</template>
<script>
import Schedule from '@/components/Schedule'
export default {
  components: {
    Schedule,
  },
  data () {
    return {
      installed: false,
      lastVer: '1.0.3',
      currVer: '',
    }
  },
  computed: {
    crxHref () {
      return `/static/crx/ccms-chrome-crx-${this.lastVer}.zip`
    }
  },
  mounted () {
    this.checkCrx()
  },
  methods: {

    checkCrx () {
      const el = document.querySelector('#ccms-conrome-crx-id')
      if (!el) {
        this.installed = false
      } else {
        this.installed = true
        this.currVer = el.innerHTML
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/_layout/CrxCard.vue